import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCaretDown,
  faCaretUp,
  faComments,
  faEnvelope,
  faInfoCircle,
  faPhone,
  faPlus,
} from '@fortawesome/pro-solid-svg-icons'
import { faAlicorn } from '@fortawesome/pro-solid-svg-icons/faAlicorn'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'

export const initializeFontAwesome = (): void => {
  // Add icons as a pack
  library.add({
    faAlicorn,
    faCheck,
    faInfoCircle,
    faPhone,
    faComments,
    faPlus,
    faCaretDown,
    faCaretUp,
    faEnvelope,
  } as any)
}
